import styles from "./style.module.scss";

export const ConceptSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h2>
          Concept<span>-コンセプト-</span>
        </h2>
        <h3>欲しかった暮らしが、ここにある。</h3>
        <p>
          朝早く海に出かけて釣りを楽しみ、釣った魚を持ち帰って捌き、魚料理を囲んで仲間や家族との時間を過ごすーー。世界でも有数の漁業の町である石巻では、人々は海とともに暮らしを育んできました。石巻マリンヴィレッジの一軒家に宿泊し、地元食材を使った料理やダイビングなど”海”を起点とした暮らしにDiveしてみませんか？
        </p>
      </div>
    </section>
  );
};
